export default class ClientAuthPolicies {
  public read = false
  public readAdmin = false
  public readFinancial = false
  public updateFinancial = false
}
